// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-bottom-nav {
  position: sticky;
  bottom: 0px;
  padding: 0px 16px;
  min-height: 80px;
  background: #FFFFFF;
}
.mobile-bottom-nav .bottom-nav-container {
  display: flex;
  color: #A8A0BA;
  font-size: 0.7rem;
  gap: 1rem;
  width: 100%;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .bottom-icon {
  margin-top: calc(var(--vh, 1vh) * 1);
  height: 25px;
  width: 25px;
  background-color: #A8A0BA;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .bottom-icon-selected {
  background-color: #DA2086;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .selected {
  color: #DA2086;
  border-radius: 2px;
  font-weight: bold;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .label {
  margin-top: 5px;
  padding: 2px 4px;
}

.sticky {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
}

ion-tab-bar {
  margin-top: -1px;
}

.hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/navbar/mobile-navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AACJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACN;AACM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;AACR;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAGM;EACE,eAAA;EACA,gBAAA;AADR;;AAOA;EACE,eAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,aAAA;AAJF","sourcesContent":[".mobile-bottom-nav {\n  position: sticky;\n  bottom: 0px;\n  padding: 0px 16px;\n  min-height: 80px;\n  background: #FFFFFF;\n\n  .bottom-nav-container {\n    display: flex;\n    color: #A8A0BA;\n    font-size: 0.7rem;\n    gap: 1rem;\n    width: 100%;\n\n    .mobile-keyword {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      flex-grow: 1;\n\n      .bottom-icon {\n        margin-top: calc(var(--vh, 1vh) * 1);\n        height: 25px;\n        width: 25px;\n        background-color:#A8A0BA;\n        mask-repeat: no-repeat;\n        mask-position: center;\n        -webkit-mask-position: center;\n      }\n\n      .bottom-icon-selected {\n        background-color: #DA2086;\n      }\n\n      .selected {\n        color: #DA2086;\n        border-radius: 2px;\n        font-weight: bold;\n      }\n      .label {\n        margin-top: 5px;\n        padding: 2px 4px;\n      }\n    }\n  }\n}\n\n.sticky {\n  position: fixed;\n  top: 0;\n  z-index: 1000;\n  width: 100%;\n}\n\nion-tab-bar{\n  margin-top: -1px;;\n}\n\n.hidden {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
